export default "/images/e49297358de4ccc672adc5718ed0a663.avif";